import $ from 'jquery';

export class DossierPage {
    static matches() {
        return !!document.querySelector('[data-dossier-root]');
    }

    init() {
        this.root = document.querySelector('[data-dossier-root]');
        if (!this.root) return;

        this.paged = 1;
        this.slug = this.root.getAttribute('data-dossier-slug') || '';
        this.loading = false;

        $(this.root).on('click', '[data-dossier-load-more]', (event) => {
            event.preventDefault();
            this.loadMore();
        });
    }

    loadMore() {
        if (this.loading || !this.slug) return;
        this.loading = true;
        const nextPage = this.paged + 1;

        const button = $(this.root).find('[data-dossier-load-more]');
        button.addClass('loadMoreButton--loading');

        $.ajax({
            url: ajaxVars.url,
            type: 'GET',
            dataType: 'json',
            data: {
                action: 'dossier_ajax',
                dossier: this.slug,
                paged: nextPage,
                append: 1,
            },
        }).done((response) => {
            if (!response || !response.success) return;
            this.paged = nextPage;
            const html = $('<div>').html(response.data.html || '');
            const grid = $(this.root).find('[data-dossier-grid]').first();
            button.closest('.hubList__more').remove();
            grid.append(html.find('[data-dossier-grid]').children());
            const more = html.find('.hubList__more');
            if (more.length) {
                grid.after(more);
            }
        }).always(() => {
            this.loading = false;
            button.removeClass('loadMoreButton--loading');
        });
    }
}
